import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProcessedFile, ProcessingItem } from '../../../models/data-feed.model';

@Component({
    selector: 'app-data-feed-details-dialog',
    templateUrl: './data-feed-details-dialog.component.html',
    styleUrls: ['./data-feed-details-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DataFeedDetailsDialogComponent {
  file: ProcessedFile;

  constructor(
    public dialogRef: MatDialogRef<DataFeedDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { file: ProcessedFile }
  ) {
    this.file = data.file;
    if (this.file.EntityTypes && typeof this.file.EntityTypes === 'string') {
      this.file.EntityTypes = (this.file.EntityTypes as unknown as string)
        .split(',')
        .map(type => type.trim());
    } else if (!this.file.EntityTypes) {
      this.file.EntityTypes = [];
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  getIconImage(name: string): string {
    const imageMap: { [key: string]: string } = {
      'events': './assets/images/feed-event.png',
      'offers': './assets/images/feed-offer.png',
      'offertags': './assets/images/feed-event.png',
      'assets': './assets/images/feed-asset.png',
      'products': './assets/images/feed-product.png',
      'productcategories': './assets/images/feed-product.png',
      'printpages': './assets/images/feed-print.png',
      'stores': './assets/images/feed-store.png'
    };
    return imageMap[name.toLowerCase()] || './assets/images/default-image.png';
  }

  getTotalItemCount(item: ProcessingItem): number {
    const processed = parseInt(item.Processed || '0', 10);
    const failed = parseInt(item.Failed || '0', 10);
    return processed + failed;
  }

}
